module.exports = __webpack_public_path__ + "static/media/ponyo.63f66d11.jpg";